module.exports = __webpack_public_path__ + "img/full3-min.00ebbf7f.png";